import * as common from './common';
var styleUtils = Object.assign({}, common);
export { styleUtils };